import { inject } from '@angular/core';
import { UserStore } from '@lib/user/data-access';
import { AuthAppUserDto } from '@lib/user/utils';
import { BaseResponse } from '@shared/utils/interfaces';
import { catchError, EMPTY, Observable } from 'rxjs';

export const appInitializer = (): Observable<BaseResponse<AuthAppUserDto>> => {
  const userStore = inject(UserStore);
  return userStore.initUserViaAuth().pipe(catchError(() => EMPTY));
};
